
export const LANGUAGE_KEY = 'wilderPlacesLanguage';
export const defaultLocale = 'en';

export const supportedLanguages = [
  { key: "es", label: "ES", flag: "option-value-spain" },
  { key: "pt", label: "PT", flag: "option-value-portugal" },
  { key: "it", label: "IT", flag: "option-value-italy" },
  { key: "ro", label: "RO", flag: "option-value-romania" },
  { key: "de", label: "DE", flag: "option-value-germany" },
  { key: "fr", label: "FR", flag: "option-value-france" },
  { key: "en", label: "EN", flag: "option-value-great-britain" },
];

function exist() {
  return typeof window !== 'undefined' && window.localStorage;
}

function set(locale) {
  if (!exist) {
    return;
  }
  window.localStorage.setItem(LANGUAGE_KEY, locale);
  reload();
}

function get() {
  return (exist() && window.localStorage.getItem(LANGUAGE_KEY)) || defaultLocale;
}

function reload() {
  if (typeof document === undefined) {
    return;
  }
  document.location.reload(true);
}


function labelsTranslator(labelKey, intl) {
  
  return intl.formatMessage({ id: `CustomLabel.${labelKey}` });
};

export const languagesHelper = {
  set,
  get,
  exist,
  labelsTranslator
};
